import { Xmark } from "@gravity-ui/icons";
import { Alert, Button, Icon } from "@gravity-ui/uikit";
import { useAction } from "@reatom/npm-react";
import { OptionProps } from "react-select";
import { ShowConfirmDialog } from "src/widgets/Alert/Alert";

import { deleteProductSampleRequest } from "../../store/fetchers";
import { ProductSampleOption } from "../../store/fetchers/getProductSamplesRequest";

export const CustomOption = (
  props: OptionProps<ProductSampleOption, false>,
) => {
  const { children, innerProps, innerRef, isSelected, isFocused } = props;

  const deleteProductSample = useAction(deleteProductSampleRequest);
  return (
    <div
      {...innerProps}
      ref={innerRef}
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "8px 12px",
        cursor: "pointer",
        backgroundColor:
          isSelected || isFocused ? "var(--g-color-base-simple-hover)" : "",
      }}
    >
      <span>{children}</span>
      <Button
        view="flat"
        onClick={(e: React.MouseEvent<HTMLButtonElement>) => {
          e.stopPropagation();

          return ShowConfirmDialog(
            <Alert
              theme="danger"
              title={`Удаление выборки: ${props.data.label}`}
              message="Вы уверены что хотите продолжить?"
            />,
            "Подтвердите действие",
          ).then((result) => {
            if (result) {
              deleteProductSample(props.data.value);
            }
          });
        }}
        style={{
          background: "none",
          border: "none",
          cursor: "pointer",
          padding: 0,
        }}
      >
        <Icon data={Xmark} size={14} />
      </Button>
    </div>
  );
};
